import { render, staticRenderFns } from "./JobApplicants.vue?vue&type=template&id=20a386e7&scoped=true"
import script from "./JobApplicants.vue?vue&type=script&lang=js"
export * from "./JobApplicants.vue?vue&type=script&lang=js"
import style0 from "./JobApplicants.vue?vue&type=style&index=0&id=20a386e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a386e7",
  null
  
)

export default component.exports